module.exports = "https://static.wmbcdn.com/uniweb/images/088788bba856ece8cdf389c21fac5d2b.svg";